var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconPlay48 = function SvgAIconPlay48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "white",
    fillOpacity: 0.3,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0588 22.1656L21.2739 15.3717C19.8731 14.3991 18 15.4486 18 17.2061L18 30.7939C18 32.5514 19.8731 33.6009 21.2739 32.6283L31.0588 25.8344C32.3137 24.9631 32.3137 23.0369 31.0588 22.1656Z",
    stroke: "white",
    strokeWidth: 2
  })));
};
export { SvgAIconPlay48 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiBmaWxsPSJub25lIiBzdHJva2U9Im5vbmUiPgo8Y2lyY2xlIGN4PSIyNCIgY3k9IjI0IiByPSIyMyIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC4zIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPHBhdGggZD0iTTMxLjA1ODggMjIuMTY1NkwyMS4yNzM5IDE1LjM3MTdDMTkuODczMSAxNC4zOTkxIDE4IDE1LjQ0ODYgMTggMTcuMjA2MUwxOCAzMC43OTM5QzE4IDMyLjU1MTQgMTkuODczMSAzMy42MDA5IDIxLjI3MzkgMzIuNjI4M0wzMS4wNTg4IDI1LjgzNDRDMzIuMzEzNyAyNC45NjMxIDMyLjMxMzcgMjMuMDM2OSAzMS4wNTg4IDIyLjE2NTZaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIC8+Cjwvc3ZnPg==";